<script>
  import ErrorMessage from './error-message.svelte'
  let { form, children, allowEnterSubmit = false, errorKeys = [], populateErrors = true, showErrors = true, ...restProps } = $props()

  let formRef = $state(null)

  let globalErrorKeys = $state([])
  
  function handleKeyDown(e) {
    const textareaFocused = document.activeElement.tagName.toLowerCase() === "textarea" || document.activeElement.isContentEditable
    if (!allowEnterSubmit && e.key === "Enter" && !textareaFocused) {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  let keys = $state([])
  let lastFocusedErrorKey = null

  $effect(() => {
    if (!populateErrors) return

    // First find all inputs
    let inputs = Array.from(formRef.querySelectorAll("input, select, textarea"))

    // Set the first error input (if exists)
    const firstErrorInput = inputs.find(input => $form?.errors[input.name])

    // Set the error keys for any error keys that are not associated with an input
    globalErrorKeys = Object.keys($form?.errors || {}).filter(key => !inputs.some(input => input.name === key))

    // Only focus the first error input when errors actually change
    const errorKey = JSON.stringify($form?.errors || {})
    if (firstErrorInput && errorKey !== lastFocusedErrorKey) {
      lastFocusedErrorKey = errorKey
      firstErrorInput.focus()
    }
  })
</script>

<form {...restProps} onkeydown={handleKeyDown} bind:this={formRef}>
  {#if form && showErrors}
    <ErrorMessage form={form} />
  {/if}
  {@render children?.()}
</form>